import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Styles.css';
import Util from './ait/Util.js';
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';

const SignUp = ({onSignup}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [webId, setWebId] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // State to manage spinner visibility
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const navigate = useNavigate();

  const {executeRecaptcha} = useGoogleReCaptcha();


  // Function to call the server-side API
  const signupFunc = async () => {
    let emailStr = email.trim().toLowerCase();  
    let webIdStr = webId.trim().toLowerCase();


    if(!executeRecaptcha) alert("Recaptcha not ready");

    const recaptchaToken = await executeRecaptcha("signup");
    
    setError(''); // Clear any existing error messages
    setLoading(true); // Show the spinner while processing

    const command = Util.serverName + "/api/registerUser"; // Base API endpoint

    console.log("captcha token: ", recaptchaToken);
    try {
      // Make the API call using POST method with a JSON body
      const response = await fetch(command, {
        method: 'POST', // Use POST method
        headers: { 'Content-Type': 'application/json' }, // Specify JSON format
        body: JSON.stringify({ email: emailStr, password, webId: webIdStr, captcha:recaptchaToken }), // JSON payload
      });

      const data = await response.json(); // Parse the JSON response

      if (!response.ok) {
        // Handle HTTP errors
        // console.log("Response: "+response.message);
        // console.log("ResponseData: "+data.message);
        throw new Error(data.message || 'Something went wrong');
      }

      if (!data.status) {
        // Handle application-specific errors (e.g., if `status` is false)
        throw new Error(data.message);
      }

      // Navigate to the email verification page if everything is successful
      // navigate('/email-verification');
      onSignup(1);
      navigate('/registered');
    } catch (error) {
      // Set the error message to be displayed to the user      
      setError(error.message);
    } finally {
      // Always remove the loading state, whether the request succeeded or failed
      setLoading(false);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    let ut = Util.getInstance();
    // Validate input fields
    if (!email || !password || !webId) {
      setError('All fields are required.');
      return;
    }

    let rt=ut.validateEmail(email);
    if(!rt.valid)
    {
      setError(rt.message);
      return;
    }

    if(!ut.isStrongPassword(password))
    {
      let msg = 'password is not strong enough. Ensure length is greater than 8, atleast 1 lowercase, at least 1 uppercase, at least 1 digit and at least 1 special character';
      setError(msg);
      return;
    }

    if(webId.length >= 12)
    {
      setError('WebId must be less than 12 characters, must be alphanumeric and have no blank spaces before or after');
      return;
    }

    if(!ut.isAlphanumeric(webId))
    {
      setError('WebId contains an invalid character in it');
      return;
    }

    await signupFunc();
    console.log("waiting for signupFunc to complete");


    /*
    setError('');
    setLoading(true); // Show the spinner while processing

    try {
      // Simulate sign-up logic (e.g., send data to backend)
      console.log('User signed up with:', { email, password, userId });

      // Simulating a delay to mimic backend processing
      // await new Promise((resolve) => setTimeout(resolve, 2000));

      // Navigate to email verification page
      // navigate('/email-verification');
    } catch (err) {
      console.error('Error during sign-up:', err);
      setError('An error occurred. Please try again at a later time.');
    } finally {
      setLoading(false); // Hide the spinner
    }
    */
  };

  const handleBackClick = () => {
    navigate('/'); // Navigate back to the home page
  };

  const eye = '\u{1F441}'; // Eye symbol using Unicode escape
  const crossedOutEye = '\u{1F648}'; // Crossed-out eye symbol

  return (
    <div className="app-container">
      {loading && (
        <div className="spinner-overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className={`container ${loading ? 'disabled-container' : ''}`}>
        <h1 className="title">Sign Up</h1>
        <p className="subtitle">Create an account to get started.</p>

        {/* Display error message */}
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="sign-up-form">
          <div className="form-group">
            <input
              type="email"
              placeholder="Email (Login ID)"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-input"
              required
            />
          </div>

          <div className="form-group password-field">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="form-input"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="toggle-password-btn"
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {!showPassword ? crossedOutEye : eye}
            </button>
          </div>
          <div className="form-group">
            <input
              type="text"
              placeholder="Short Web ID (for your sub-directory)"
              value={webId}
              onChange={(e) => setWebId(e.target.value)}
              className="form-input"
              required
            />
          </div>
          <button type="submit" className="button" disabled={loading}>
            Sign Up
          </button>
        </form>

        <div className="alternative-action">
          <p>
            Already have an account? <a href="/login">Log in here</a>
          </p>
        </div>

        <button onClick={handleBackClick} className="button back-btn">
          Home Page
        </button>
      </div>
    </div>
  );
};

export default SignUp;



